import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import PhotoBook1 from "../../assets/img/PhotoBook-5x5.jpg";
import PhotoBook2 from "../../assets/img/PhotoBook-6x8.jpg";
import PhotoBook3 from "../../assets/img/PhotoBook-8x6.jpg";
import PhotoBook4 from "../../assets/img/PhotoBook-8x8.jpg";
import PhotoBook5 from "../../assets/img/PhotoBook-8x8.jpg";
import PhotoBook6 from "../../assets/img/PhotoBook-8x10.jpg";
import PhotoBook7 from "../../assets/img/PhotoBook-8x11.jpg";
import PhotoBook8 from "../../assets/img/PhotoBook-8x8.jpg";
import Mix from "../../assets/img/mix.svg";
import One from "../../assets/img/one.svg";
import Two from "../../assets/img/two.svg";
import Three from "../../assets/img/three.svg";
import Four from "../../assets/img/four.svg";
import Forty from "../../assets/img/forty.svg";
import Sixty from "../../assets/img/sixty.svg";
import Eighty from "../../assets/img/eighty.svg";
import Info from "../../assets/img/info.svg";
import Header from "../../Components/Header";

const headerLinks = [{ name: "Home", href: "/" }];
export default function PhotoesPerPage()  {

    const [activeSection, setActiveSection] = useState(1);
    const [showButton, setShowButton] = useState(false);
    const [showBorder, setShowBorder] = useState(0);
    const navigate = useNavigate();
    const handleRadioButton = (value: boolean, index: number) => {
        setShowButton(value);
        setShowBorder(index);
      };

      const onSelectProductOrientation=()=>{
        navigate("/choosepagecount", { replace: true });
      }

    return(
        <><Header cartItemsCount={0} title="My Website" links={headerLinks} /><div>
            <section className="PhotosPerPage">
                <div className="mx-auto max-w-7xl mt-10 mb-40  px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-normal text-left">
                        {" "}
                        Select a Product Orientations
                    </h1>
                    <p className="text-lg text-gray-800 mt-3">How many photos would you like to start with on each page?</p>
                    <p className="text-sm text-gray-600 mt-2"> You can still change the layout on any page once your project is created.</p>
                    <div className="flex justify-left mt-8">
                        <div
                            className={(showBorder === 1 ? "border-slate-sel" : "") +
                                " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                        >
                            <div className="flex flex-col items-center">
                                <img
                                    src={Mix}
                                    alt="Xceedprintsolutions"
                                    className="h-20 w-auto" />
                                <h5 className="mb-1 text-sm font-medium text-gray-900 pt-3">
                                    Mix it up!
                                </h5>
                                <span className="pt-0">
                                    <input
                                        type="radio"
                                        className="h-5 w-5"
                                        name="productorientations"
                                        onClick={() => handleRadioButton(true, 1)} />
                                </span>
                            </div>
                        </div>
                        <div
                            className={(showBorder === 2 ? "border-slate-sel" : "") +
                                " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                        >
                            <div className="flex flex-col items-center">
                                <img
                                    src={One}
                                    alt="Xceedprintsolutions"
                                    className="h-20 w-auto" />
                                <h5 className="mb-1 text-sm font-medium text-gray-900 pt-3">
                                    photo per page
                                </h5>
                                <span className="pt-0">
                                    <input
                                        type="radio"
                                        className="h-5 w-5"
                                        name="productorientations"
                                        onClick={() => handleRadioButton(true, 2)} />
                                </span>
                            </div>
                        </div>
                        <div
                            className={(showBorder === 3 ? "border-slate-sel" : "") +
                                " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                        >
                            <div className="flex flex-col items-center">
                                <img
                                    src={Two}
                                    alt="Xceedprintsolutions"
                                    className="h-20 w-auto" />
                                <h5 className="mb-1 text-sm font-medium text-gray-900 pt-3">
                                    photo per page
                                </h5>
                                <span className="pt-0">
                                    <input
                                        type="radio"
                                        className="h-5 w-5"
                                        name="productorientations"
                                        onClick={() => handleRadioButton(true, 3)} />
                                </span>
                            </div>
                        </div>
                        <div
                            className={(showBorder === 4 ? "border-slate-sel" : "") +
                                " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                        >
                            <div className="flex flex-col items-center">
                                <img
                                    src={Three}
                                    alt="Xceedprintsolutions"
                                    className="h-20 w-auto" />
                                <h5 className="mb-1 text-sm font-medium text-gray-900pt-3">
                                    photo per page
                                </h5>
                                <span className="pt-0">
                                    <input
                                        type="radio"
                                        className="h-5 w-5"
                                        name="productorientations"
                                        onClick={() => handleRadioButton(true, 4)} />
                                </span>
                            </div>
                        </div>
                        <div
                            className={(showBorder === 5 ? "border-slate-sel" : "") +
                                " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                        >
                            <div className="flex flex-col items-center">
                                <img
                                    src={Four}
                                    alt="Xceedprintsolutions"
                                    className="h-20 w-auto" />
                                <h5 className="mb-1 text-sm font-medium text-gray-900 pt-3">
                                    photo per page
                                </h5>
                                <span className="pt-0">
                                    <input
                                        type="radio"
                                        className="h-5 w-5"
                                        name="productorientations"
                                        onClick={() => handleRadioButton(true, 5)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    {showButton && (
                        <div className="flex justify-center">
                            <div className="mt-10 w-80">
                                
                                    <button
                                        onClick={()=>onSelectProductOrientation()}
                                        type="submit"
                                        className="w-full uppercase py-2 px-4 bg-green font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"

                                    >
                                        Continue
                                    </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div></>
    )
}
